
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsbb3f69594e583824bb8511f1d3e131d2en from './en.yaml'
            i18n.addResourceBundle('en', 'bb3f69594e583824bb8511f1d3e131d2', flattenObject(nsbb3f69594e583824bb8511f1d3e131d2en), true, true);
        
        export default 'bb3f69594e583824bb8511f1d3e131d2';
    